module.exports = __webpack_public_path__ + "static/img/bean_500.6732d3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bean_500.png
// module id = 505
// module chunks = 1